var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.88 14.8268V8.97342C27.88 7.88009 27.0533 6.64009 26.0267 6.22676L18.6 3.18676C16.9333 2.50676 15.0533 2.50676 13.3867 3.18676L5.96 6.22676C4.94666 6.64009 4.12 7.88009 4.12 8.97342V14.8268C4.12 21.3468 8.85333 27.4534 15.32 29.2401C15.76 29.3601 16.24 29.3601 16.68 29.2401C23.1467 27.4534 27.88 21.3468 27.88 14.8268ZM17 17.1601V20.6668C17 21.2134 16.5467 21.6668 16 21.6668C15.4533 21.6668 15 21.2134 15 20.6668V17.1601C13.6533 16.7334 12.6667 15.4801 12.6667 14.0001C12.6667 12.1601 14.16 10.6668 16 10.6668C17.84 10.6668 19.3333 12.1601 19.3333 14.0001C19.3333 15.4934 18.3467 16.7334 17 17.1601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.09b9f2ff5b21300dd626852046f0dd05.svg";
export { ForwardRef as ReactComponent };